import styled from "styled-components";

export const TsrWithDropdownOptionSelectorBox = styled.div`
    max-width: 289px;
    margin: 0.5rem auto 0;

    @media ${({theme}) => `${theme.mediaQuery.lAndBelow} and ${theme.mediaQuery.landscape}`} {
        margin-bottom: 2rem;
    }
`;